/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

export const FETCH_SECURITY_REALMS = 'FETCH_SECURITY_REALMS'
export const REORDER_SECURITY_REALMS = 'REORDER_SECURITY_REALMS'

export const FETCH_SECURITY_CLUSTER = 'FETCH_SECURITY_CLUSTER'
export const CREATE_SECURITY_CLUSTER = 'CREATE_SECURITY_CLUSTER'

export const FETCH_ACTIVE_DIRECTORY_SETTINGS = 'FETCH_ACTIVE_DIRECTORY_SETTINGS'
export const CREATE_ACTIVE_DIRECTORY_SECURITY_REALM = 'CREATE_ACTIVE_DIRECTORY_SECURITY_REALM'
export const UPDATE_ACTIVE_DIRECTORY_SECURITY_REALM = 'UPDATE_ACTIVE_DIRECTORY_SECURITY_REALM'
export const DELETE_ACTIVE_DIRECTORY_SECURITY_REALM = 'DELETE_ACTIVE_DIRECTORY_SECURITY_REALM'

export const FETCH_LDAP_SETTINGS = 'FETCH_LDAP_SETTINGS'
export const CREATE_LDAP_SECURITY_REALM = 'CREATE_LDAP_SECURITY_REALM'
export const UPDATE_LDAP_SECURITY_REALM = 'UPDATE_LDAP_SECURITY_REALM'
export const DELETE_LDAP_SECURITY_REALM = 'DELETE_LDAP_SECURITY_REALM'

export const FETCH_SAML_SETTINGS = 'FETCH_SAML_SETTINGS'
export const CREATE_SAML_SECURITY_REALM = 'CREATE_SAML_SECURITY_REALM'
export const UPDATE_SAML_SECURITY_REALM = 'UPDATE_SAML_SECURITY_REALM'
export const DELETE_SAML_SECURITY_REALM = 'DELETE_SAML_SECURITY_REALM'

export const FETCH_USER_OKTA_GROUPS = 'FETCH_USER_OKTA_GROUPS'
export const UPDATE_USER_OKTA_GROUPS = 'UPDATE_USER_OKTA_GROUPS'

// SaaS organizations
export const RETRY_PAST_DUE_INVOICES = `RETRY_PAST_DUE_INVOICES`

// SaaS users
export const REQUEST_USER_DELETION = `REQUEST_USER_DELETION`
export const SET_USER_SEARCH_TYPE = `SET_USER_SEARCH_TYPE`
export const SET_USER_SEARCH_TERM = `SET_USER_SEARCH_TERM`
export const SEARCH_USERS = `SEARCH_USERS`
export const RESET_SEARCH_USERS = `RESET_SEARCH_USERS`
